/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.find.js";
import $$ from '@/store/plugins/storage';
var namespace = 'global';
$$.setNamespace(namespace);
var state = {
  projectState: [{
    value: -1,
    name: '全部',
    color: ''
  }, {
    value: 1,
    name: '进行中',
    color: '#00a0e9'
  }, {
    value: 2,
    name: '未发货',
    color: '#606266'
  }, {
    value: 3,
    name: '已完成',
    color: '#2ca104'
  }],
  dispatchState: [{
    value: 0,
    name: '待受理',
    color: '#ee4221'
  }, {
    value: 1,
    name: '待指派',
    color: '#3da8f6'
  }, {
    value: 2,
    name: '待预约',
    color: '#613cff'
  }, {
    value: 3,
    name: '待服务',
    color: '#ff9c00'
  }, {
    value: 4,
    name: '服务中',
    color: '#00a0e9'
  }, {
    value: 5,
    name: '已完成',
    color: '#2ca104'
  }, {
    value: 6,
    name: '已关单',
    color: '#606266'
  }],
  problemFormState: [{
    value: 0,
    name: '待提交',
    color: '#ee4221'
  }, {
    value: 1,
    name: '待审批',
    color: '#019894'
  }, {
    value: 2,
    name: '已通过',
    color: '#2ca104'
  }, {
    value: 3,
    name: '已驳回',
    color: '#ee4221'
  }],
  problemState: [{
    value: '',
    name: '全部'
  }, {
    value: 1,
    name: '待审批'
  }, {
    value: 2,
    name: '未解决'
  }, {
    value: 3,
    name: '已解决'
  }],
  afterSaleState: [{
    value: '',
    name: '全部'
  }, {
    value: 1,
    name: '待处理'
  }, {
    value: 2,
    name: '采购中'
  }, {
    value: 3,
    name: '已发货'
  }],
  complaintState: [{
    value: '',
    name: '全部'
  }, {
    value: 1,
    name: '待处理'
  }, {
    value: 2,
    name: '处理中'
  }, {
    value: 3,
    name: '已完成'
  }],
  approvetState: [{
    value: '',
    name: '全部'
  }, {
    value: 1,
    name: '已审批'
  }, {
    value: 2,
    name: '未审批'
  }],
  settleState: [{
    value: '',
    name: '全部'
  }, {
    value: 1,
    name: '待申报'
  }, {
    value: 2,
    name: '待审批'
  }, {
    value: 3,
    name: '待提交'
  }, {
    value: 4,
    name: '已提交'
  }],
  projectType: [{
    name: '出厂安装',
    value: 1
  }, {
    name: '有偿维保',
    value: 2
  }, {
    name: '有偿改造',
    value: 3
  }, {
    name: '临时项目',
    value: 4
  }],
  orderType: [{
    name: '出厂安装',
    value: 1
  }, {
    name: '售后服务',
    value: 2
  }, {
    name: '报废回收',
    value: 8
  } // { name: '有偿改造', value: 4 },
  // { name: '外部服务', value: 5 },
  // { name: '整站外包', value: 6 }
  ],
  approvalState: [{
    value: 0,
    name: '待审批'
  }, {
    value: 1,
    name: '已通过'
  }],
  customerSource: [{
    name: '一线销售',
    value: 1
  }, {
    name: '服务销售',
    value: 2
  }, {
    name: '合作伙伴',
    value: 3
  }],
  serviceInformation: [{
    name: '一线销售',
    value: 1
  }, {
    name: '服务销售',
    value: 2
  }, {
    name: '合作伙伴',
    value: 3
  }],
  commissionState: [{
    value: 1,
    name: '整站委托'
  }, {
    value: 2,
    name: '应急处理委托'
  }, {
    value: 3,
    name: '维保服务委托'
  }, {
    value: 4,
    name: '外包服务委托'
  }],
  nodeState: [{
    value: 0,
    name: '未开始'
  }, {
    value: 1,
    name: '进行中'
  }, {
    value: 2,
    name: '已安装'
  }],
  causeType: [{
    value: 1,
    name: '生产'
  }, {
    value: 2,
    name: '设计'
  }, {
    value: 3,
    name: '客户'
  }, {
    value: 4,
    name: '售后'
  }, {
    value: 5,
    name: '物流'
  }, {
    value: 6,
    name: '质量问题等'
  }],
  processState: [{
    value: 0,
    name: '未处理'
  }, {
    value: 1,
    name: '已处理'
  }],
  returnState: [{
    value: 0,
    name: '未关闭'
  }, {
    value: 1,
    name: '已关闭'
  }],
  productCategory: [{
    value: 1,
    name: '维保'
  }, {
    value: 2,
    name: '改造'
  }, {
    value: 3,
    name: '扩容'
  }, {
    value: 4,
    name: '备件'
  }, {
    value: 5,
    name: '新项目'
  }],
  followStatus: [{
    value: 1,
    name: '跟进中'
  }, {
    value: 2,
    name: '跟进完成'
  }, {
    value: 3,
    name: '跟进失败'
  }],
  supplyMethods: [{
    value: 1,
    name: '外包（华电不提供售后服务）'
  }, {
    value: 2,
    name: '外购（服务含测量、指导安装）'
  }, {
    value: 3,
    name: '自制（服务含测量、指导安装）'
  }],
  cusProList: [{
    value: 1,
    name: '合作伙伴'
  }, {
    value: 2,
    name: '经销商'
  }, {
    value: 3,
    name: '盘厂'
  }, {
    value: 4,
    name: '总包'
  }, {
    value: 5,
    name: '运维单位'
  }]
};
var getters = {
  getStateName: function getStateName(state) {
    return function (value, stateName) {
      var tmp = state[stateName].find(function (v) {
        return v.value === value;
      });
      return tmp || {
        name: '未知',
        color: '#11d8fb'
      };
    };
  }
};
var mutations = {};
var actions = {};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};